<template>
  <div class="register_main">
    <div class="register">
          <div class="register_dom account">
            <input
              type="text"
              class=""
              placeholder="帳號限6-18字元"
              maxlength="18"
              @blur="regx(1)"
              v-model="userInfo.account"
            />
            <div class="error_" v-if="rules.account">请正確輸入賬號</div>
          </div>
          <div class="register_dom password">
            <input
              type="password"
              class=""
              placeholder="密碼限6-18字元"
              maxlength="18"
              @blur="regx(2)"
              v-model="userInfo.password"
            />
            <div class="error_" v-if="rules.password">请正確輸入密碼</div>
          </div>
          <div class="register_dom password_again">
            <input
              type="password"
              class=""
              maxlength="18"
              @blur="regx(3)"
              placeholder="密碼區分大小寫"
              v-model="userInfo.passwordAgain"
            />
            <div class="error_" v-if="rules.passwordAgain">兩次密碼不一致</div>
          </div>
          <div class="register_dom email">
            <input
              type="text"
              class=""
              @blur="regx(4)"
              placeholder="電子郵箱以便找回密碼"
              v-model="userInfo.email"
            />
            <div class="error_"  v-if="rules.email">请正確輸入郵箱</div>
          </div>
          <div class="register_dom code">
            <input type="text" v-model="userInfo.code" />
            <img :src="captcha.image" class="capImage" v-show="captcha.key!=''" @click="drawCode" alt="">
          </div>
          <div class="agree" :class="agreeRule ? 'agreed' : ''">
            <div class="agreed_box" @click="agreeRules"></div>
            <a
              href="https://www.hermesgames.com.tw/#/customerCenter"
              target="_blank"
              ><div class="user_agreed"></div
            ></a>
          </div>
          
        </div>
        <img src="../assets/pc/sure.png" @click="registerFn" alt="" class="sure" />
        <img src="../assets/pc/x.png" @click="closedandos" alt="" class="close" />
  </div>
</template>
<script>
export default {
  name:'Register',
  data(){
    return{
      userInfo: {
        account: "",
        password: "",
        passwordAgain: "",
        email: "",
        code: "",
      },
      rules:{
        account:false,
        password:false,
        passwordAgain:false,
        email:false,
        code:false,
      },
      show_num:[],
      agreeRule:false,
      switchs:true,
      captcha:{
        image:'',
        key:''
      }
    }
  },
  mounted(){
    this.getCaptcha()
  },
  methods:{
    drawCode(){
      this.getCaptcha()
    },
    agreeRules(){
      this.agreeRule = !this.agreeRule;
    },
    regx(e){
      if(e==1){
        if(this.userInfo.account.length<6){
          this.rules.account = true
        }else{
          this.rules.account = false
        }
      }
      if(e==2){
        if(this.userInfo.password.length<6){
          this.rules.password = true
        }else{
          this.rules.password = false
        }
      }
      if(e==3){
        if(this.userInfo.password!=this.userInfo.passwordAgain){
          this.rules.passwordAgain = true
        }else{
          this.rules.passwordAgain = false
        }
      }
      if(e==4){
        if(/^([a-zA-Z\d])((\w|-)+\.?)+@([a-zA-Z\d]+\.)+[a-zA-Z]{2,6}$/.test(this.userInfo.email)){
          this.rules.email = false
        }else{
          this.rules.email = true
        }
      }
    },
    registerFn(){
      if(!this.agreeRule){
        this.$layer.msg('請勾選接受協議');
        return
      }
      this.regx(1);this.regx(2);this.regx(3);this.regx(4);
      let switchs = false;
      for(let i in this.rules){
        if(this.rules[i]){
          switchs = true
        }
      }
      
      if(!switchs){
        let data = {
          account:this.userInfo.account,
          email:this.userInfo.email,
          password:this.userInfo.password,
          password_confirmation:this.userInfo.passwordAgain,
          captcha:this.userInfo.code,
          key:this.captcha.key
        }
        this.postHttp(this,data,'/api/v4/register',function(obj,res){
         
          if(res.code==200){
             obj.$emit('openSuccess');
             obj.$emit('closedando');
            
             obj.getCaptcha();
          }else{
            obj.getCaptcha();
             obj.$layer.msg(res.message);
          }
         
        })
      }
    },
    getCaptcha(){
      this.getHttp(this,'','/api/v4/getCaptcha',function(obj,res){
        obj.captcha.image = res.image;
        obj.captcha.key = res.key;
      })
    },
    closedandos(){
      this.$emit('closedando');
    }
  }
}
</script>
<style lang="scss" scope>
  .register_main{
    width: 6rem;
    height: 6.4rem;
    background: url('../assets/pc/layerbg.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    margin-left: -3rem;
    top: 50%;
    margin-top: -3.2rem;
    .register {
      width: 4rem;
      height: 3.7rem;
      background: url("../assets/pc/resign.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      top: 1rem;
      left: 50%;
      margin-left: -2rem;
      .register_dom {
        position: absolute;
        width: 2.4rem;
        height: 0.6rem;
        top: 0rem;
        left: 50%;
        margin-left: -0.3rem;
        input {
          width: 2.4rem;
          height: 0.4rem;
          line-height: 0.4rem;
          border: 0;
          outline: 0;
          padding: 0 5px;
          font-size: 0.15rem;
          color: #ba9e5a;
          display: block;
        }
        .error_ {
          font-size: 0.14rem;
          color: red;
          width: 100%;
          left: 0;
          bottom: 0;
        }
      }
      .password {
        top: .8rem;
      }
      .password_again {
        top: 1.65rem;
      }
      .email {
        top: 2.45rem;
      }
      .code {
        top: 3.3rem;
        input {
          width: 1rem;
        }
        .capImage{
          width: 1rem;
          height: .4rem;
          display: block;
          position: absolute;
          top: 0;
          right: 0.1rem;
          cursor: pointer;
        }
        #canvas,.canvasDown,.canvasUp {
          position: absolute;
          right: 0;
          top: 0;
          width: 80px;
          height: 30px;
          z-index: 2;
        }
        .canvasDown{
          z-index: 1;
          background-color: white;
        }
        .canvasUp{
          z-index: 3;
          cursor: pointer;
        }
      }
      .agree{
        width:4.5rem;
        height: .6rem;
        background: url("../assets/pc/ruledsed.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 3.8rem;
        left: -.2rem;
         .agreed_box {
          width: 0.5rem;
          height: 0.5rem;
          position: absolute;
          top: 0;
          left: 0;
          cursor: pointer;
        }
        .user_agreed {
          width: 2rem;
          height: 0.5rem;
          position: absolute;
          top: 0;
          right: 0;
          cursor: pointer;
        }
      }
      .agreed{
        background: url("../assets/pc/ruleds.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .sure{
        width: 2.5rem;
        cursor: pointer;
        margin: auto;
        position: absolute;
        bottom: 0.2rem;
        left: 50%;
        margin-left: -1.25rem;
    }
    .close{
      position: absolute;
        width: .8rem;
        height: .75rem;
        cursor: pointer;
        top: .2rem;
        right: .2rem;
    }
  }
</style>